import { gql } from '@apollo/client';

export default gql`
  mutation updateCustomerPassengers($bookingReference: String!, $passengers: [InputPassenger]!, $customer: CustomerInput!) {
    updatePassengers(bookingReference: $bookingReference, passengers: $passengers) {
      reference
    }

    updateCustomer(bookingReference: $bookingReference, customer: $customer) {
      reference
    }
  }
`;
